import React from "react";
import InterviewerSettings from "./InterviewerSettings";

const AccountSettingPage = () => (
  <div className="min-h-screen w-full flex bg-[#F6F7F9] dark:bg-gray-900">
    <main className="flex-1 min-h-screen bg-white dark:bg-gray-900 p-10 transition-colors duration-250">
      <h2 className="text-base font-semibold text-slate-800 dark:text-white mb-8">Account Settings</h2>

      {/* Interviewer Management Section */}
      <section className="mb-10">
        <InterviewerSettings />
      </section>
    </main>
  </div>
);

export default AccountSettingPage;
